<template>
  <v-card class="mt-8">
    <v-card-text class="px-10">
      <div v-if="$getLoggedUser().has_club || ($getLoggedUser().has_club && $getIsEcommerce())">
        <div class="delivery-toggle">
          <mf-toggle v-model="productForms.deliveryRestriction.active" class="pb-n10" label="Apenas retirada no estabelecimento" hide-details />
        </div>
        <p class="mt-2 subtitle">Os produtos que permitem somente retirada não poderão ser comprados para entrega em estabelecimento através do e-commerce.</p>
      </div>
      <v-divider v-if="productForms.isMedicine"></v-divider>
      <mf-toggle v-if="productForms.isMedicine" v-model="productForms.isMedicine" class="pb-n10" label="Venda com prescrição médica" hide-details />
      <p v-if="productForms.isMedicine" class="mt-2 subtitle"></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProductRemoval',
  inject: ['userHasPermission'],
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss">
div.v-input__control > div.v-input__slot > .v-input .v-input__slot {
  color: $cinza-d10;
  font-size: 18px;
}

.delivery-toggle {
  .v-label {
    font-size: 16px !important;
    color: $cinza-d20 !important;
  }
}
</style>
